import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {SalesVerificationCodeComponent} from "./sales-verification-code.component";
import {SalesVerificationCodeComponentV3} from "./versions/sales-verification-code-versions.component";
import {LibraryModule} from "library";
import {PrimengModule} from "../../shared/primeng-module/primeng.module";
import {ReactiveFormsModule, FormsModule} from "@angular/forms";
import {GeneralModule} from "../general/general.module";

@NgModule({
  declarations: [
    SalesVerificationCodeComponent,
    SalesVerificationCodeComponentV3
  ],
  imports: [
    CommonModule,
    LibraryModule,
    PrimengModule,
    ReactiveFormsModule,
    FormsModule,
    GeneralModule
  ],
  exports: [
    SalesVerificationCodeComponent,
    SalesVerificationCodeComponentV3
  ]
})
export class SalesVerificationCodeModule { }